import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  ON24 Home & Living

  <span style="color:#85c1dc;">**FI:**</span>
  ON24 Home & Living

  <span style="color:#85c1dc;">**RU:**</span>
  ON24 Home & Living
*/
/* @__NO_SIDE_EFFECTS__ */
const m1736 = msg(
  mf`ON24 Home & Living`,
  mf`ON24 Home & Living`,
  mf`ON24 Home & Living`,
)

export { m1736 as 'meta.title.add' }